import {
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {combineLatest, Observable } from "rxjs";
import { filter, takeWhile } from "rxjs";
import {ListerPageTitleService} from "@common/components/lister-page-title/lister-page-title.service";
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";

@Component({
  selector: "lister-page-title",
  templateUrl: "./lister-page-title.component.html",
})
export class ListerPageTitleComponent
  implements OnInit, OnDestroy {

  title$: Observable<string>;
  isAlive: boolean = true;

  constructor(
    private readonly entityDataLayoutService: EntityDataLayoutService,
    private readonly listerPageTitleService: ListerPageTitleService)
  { }

  ngOnInit() {
    combineLatest([
      this.entityDataLayoutService.ActivatedRoute$,
      this.entityDataLayoutService.EntityKey$,
      this.entityDataLayoutService.ViewName$
    ]).pipe(
      takeWhile(() => this.isAlive),
      filter(([activatedRoute, entityKey, viewName]) =>
        activatedRoute.snapshot?.data?.routeContext?.kind === 'ListerRouteContext')
    ).subscribe(([activatedRoute, entityKey, viewName]) => {
      this.title$ = this.listerPageTitleService.getTitle(entityKey, viewName);
    });
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}

